<template>
	<v-container fluid>
		<v-row class="ma-0 pb-2" dense>
			<v-col cols="12" md="auto">
				<div class="d-flex align-center">
					<slot name="breadcrumbs" />
				</div>
			</v-col>
			<v-col lg="2" md="3" sm="4" cols="6">
				<v-autocomplete
					v-model="filter.selectedLogType"
					outlined
					dense
					hide-details
					:label="$t('AuditLog.label.logType')"
					:items="logTypes"
					item-text="name"
					item-value="logType"
				></v-autocomplete>
			</v-col>
			<v-col lg="2" md="3" sm="4" cols="6">
				<v-autocomplete
					v-model="filter.selectedUser"
					:items="users"
					item-text="user_name"
					item-value="id"
					outlined
					hide-details
					dense
					:label="$t('AuditLog.label.user')"
				></v-autocomplete>
			</v-col>
			<v-col lg="2" md="3" sm="4" cols="6">
				<v-text-field
					v-model="filter.selectedFromDate"
					type="date"
					outlined
					dense
					hide-details
					:label="$t('AuditLog.label.fromDate')"
				></v-text-field>
				<!-- <bee-date-picker
					v-model="filter.selectedFromDate"
					:input-label="$t('AuditLog.label.fromDate')"
					menu-picker
					hide-details
					:input-props="{
						outlined: true,
						filled: true,
						dense: true,
						clearable: false,
					}"
				></bee-date-picker> -->
			</v-col>
			<v-col lg="2" md="3" sm="4" cols="6">
				<v-text-field
					v-model="filter.selectedToDate"
					type="date"
					outlined
					dense
					hide-details
					:label="$t('AuditLog.label.toDate')"
				></v-text-field>
				<!-- <bee-date-picker
					v-model="filter.selectedToDate"
					:input-label="$t('AuditLog.label.toDate')"
					menu-picker
					hide-details
					:input-props="{
						outlined: true,
						filled: true,
						dense: true,
						clearable: false,
					}"
				></bee-date-picker> -->
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="auto">
				<v-btn
					color="blueGray white--text"
					@click="needToResetItems = true; fetchAudits()"
				>{{ $t('AuditLog.search') }}</v-btn>
			</v-col>
		</v-row>
		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="[]"
			fixed-header
			:height="$vuetify.breakpoint.height - 175"
			zebra
			dense
			pagination-on-scroll
			pagination-on-scroll-server-items
			:loading="loading"
			:items-per-page="20"
			:scroll-options.sync="optionsScroll"
			shown-rows-text=""
			:data-table-props="{ disableSort: true }"
			:pagination-on-scroll-auto-reset-shown="false"
			:server-items-length="serverItemsLength"
			@pagination-on-scroll:reach-last-row="fetchAudits"
		>	
			<template v-slot:item.actionType="{ getShownValueInCell, header, item }">
				<span
					:class="{
						'info-color--text': item.type === actionType.fetch,
						'success-color--text': item.type === actionType.create,
						'alert-color--text': item.type === actionType.update,
						'danger-color--text': item.type === actionType.delete,	
						'blue--text': item.type === actionType.post,
						'grey--text text--darken-2': item.type === actionType.unPost
					}"
				>
					{{ getShownValueInCell({ item, header }) }}
				</span>
			</template>

			<template v-slot:item.logType="{ item }">
				{{ getLogType(item.log_type) }} - {{ getModelName(item.model_name) }}
			</template>
			
			<template v-slot:item.actions="{ item }">
				<v-btn
					depressed
					height="34"
					width="38"
					min-width="38"
					color="preview-color white--text"
					class="px-1"
					:loading="selectedLogId === item.entity_guid"
					@click="fetchEntityType(item.model_name, item.record_id);"
				>
					<v-icon>mdi-eye</v-icon>
				</v-btn>
			</template>
			<template v-slot:item.date="{ item }">
				<div class="d-flex justify-space-between">
					<div dir="auto" class="d-flex justify-end">
						{{ moment(item.date_formatted).locale('en').format('h:mm:ss A ,YYYY-MM-DD') }}
					</div>
				</div>
			</template>
		</bee-handy-table>
	</v-container>
</template>
<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import { logTypes, actionType, actionTypes, entryLogType, fullLogTypes } from '../../../helpers/enums';
export default {
	data() {
		return {
			loading: false,
			serverItemsLength: 0,

			optionsScroll: {},
			
			fullLogTypes,

			logTypes,
			actionType,
			actionTypes,
			filter: {
				selectedLogType: null,
				selectedUser: null,
				selectedFromDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
				selectedToDate: moment().format('YYYY-MM-DD'),
			},
			needToResetItems: false,

			selectedLogId: null,

			recordIds: null,
			modelNames: null,
			moment
		}
	},
	methods: {
		fetchAudits(newOptionsScroll, isFirstLoad = false) {
            this.loading = true;
            let page = 1 ;
            if (newOptionsScroll && !this.needToResetItems) {
                page = newOptionsScroll.page;
            }
            return this.$store.dispatch('auditLogs/fetchAll', {
				logType: this.filter.selectedLogType,
				userId: this.filter.selectedUser,
				fromDate: this.filter.selectedFromDate,
				toDate: this.filter.selectedToDate,
				financialFileId: this.current_financial_file.id,
				page, 
				perPage: 20 
			}).then((data) => {
				if (this.needToResetItems) {
					this.$refs.table.resetShownItems();
					this.needToResetItems = false;
				}
				this.serverItemsLength = data.total;
				this.$refs.table.addScrollItems(data.items);
			}).finally(() => {
				if (!isFirstLoad) this.loading = false;
			});
        },

		async fetchEntityType(modelName, recordId) {
			this.modelNames = modelName
			this.recordIds = recordId

			let entryType = this.modelNames;
			let targetId = this.recordIds;

			switch (entryType) {
				case entryLogType.accountingBonds:
				case entryLogType.accountingEntries: {
					this.$router.push({ name: 'accounting-journal', params: { id: targetId } });
					break;
				}
				case entryLogType.cashBonds:
				case entryLogType.cashEntries: {
					this.$router.push({ name: 'cash-journal', params: { id: targetId } });
					break;
				}
				case entryLogType.accounts:
				case entryLogType.contactInfos: {
					this.$router.push({ name: 'account', params: { id: targetId } });
					break;
				}
				case entryLogType.materials:
				case entryLogType.linkedMaterials: {
					const warehouseId = this.getMaterialById(targetId)?.warehouse_id;
					this.$router.push({ name: 'update-material', params: { warehouseId, id: targetId } });
					break;
				}
				case entryLogType.saleInvoices:
				case entryLogType.saleMaterialEntries:
				case entryLogType.expensesSaleInvoiceTransactions: {
					this.$router.push({ name: 'invoices-sale', params: { id: targetId }, query: { withCategory: true } });
					break;
				}
				case entryLogType.buyInvoices:
				case entryLogType.buyMaterialEntries:
				case entryLogType.expensesBuyInvoiceTransactions: {
					this.$router.push({ name: 'invoices-buy', params: { id: targetId }, query: { withCategory: true } });
					break;
				}
				case entryLogType.saleRefundInvoices:
				case entryLogType.saleRefundMaterialEntries: {
					this.$router.push({ name: 'sale-invoice-refund', params: { id: targetId },  query: { withCategory: true }  });
					break;
				}
				case entryLogType.buyRefundInvoices:
				case entryLogType.buyRefundMaterialEntries: {
					this.$router.push({ name: 'buy-invoice-refund', params: { id: targetId },  query: { withCategory: true }  });
					break;
				}
				case entryLogType.materialsJournals: {
					this.$router.push({ name: 'materials-journal', params: { id: targetId } });
					break;
				}
				case entryLogType.transactionBonds:
				case entryLogType.transactionEntries: {
					this.$router.push({ name: 'transfer-document', query: { id: targetId } });
					break;
				}
				case entryLogType.manufacturingFiles:
				case entryLogType.manufacturingFileEntries: {
					this.$router.push({ name: 'manufacturing-bond', query: { id: targetId } });
					break;
				}
				case entryLogType.manufacturingFileEntryRawMaterials: {
					this.$router.push({ name: 'create-product', query: { manufacturingFileId: targetId } });
					break;
				}
				case entryLogType.finicalFilesConfig: {
					this.$router.push({ name: 'default-accounts' });
					break;
				}
				case entryLogType.warehouses: {
					this.$router.push({ name: 'warehouses' });
					break;
				}
				case entryLogType.customStatements: {
					this.$router.push({ name: 'custom-statements' });
					break;
				}
				case entryLogType.unitSizes: {
					this.$router.push({ name: 'unit-sizes' });
					break;
				}
				case entryLogType.users: {
					this.$router.push({ name: 'users' });
					break;
				}
				case entryLogType.finicalFiles: {
					this.$router.push({ name: 'financial-files' });
					break;
				}
				case entryLogType.currencies: {
					this.$router.push({ name: 'currencies' });
					break;
				}
			}
		},
		getLogType(val) {
			return this.logTypes.find(c => c.logType === val)?.name
		},
		getModelName(val) {
			return this.fullLogTypes.find(c => c.id === val)?.name
		}
	},
	computed: {
		...mapState({
			auditLogs: state => state.auditLogs.auditLogs,
			users: state => state.users.users,
			materials: state => state.materials.materials,
			current_financial_file: state => state.financialFiles.current_financial_file,
		}),
		...mapGetters({
			getUserById: 'users/getUserById',
			getMaterialById: 'materials/getMaterialById',
			getFinancialFileById: 'financialFiles/getFinancialFileById'
		}),

		headers() {
			const headers = [
				/* {
					text: this.$t('AuditLog.headers.financialFiles'),
					value: 'financial_file_id',
					name: 'finaincialFile',
					align: 'center',
					width: 240,
					setValueExpr: (val) => this.getFinancialFileById(val)?.company_name
				}, */
				{
					text: this.$t('AuditLog.headers.user'),
					value: 'user_id',
					name: 'account',
					align: 'center',
					width: 240,
					setValueExpr: (val) => this.getUserById(val)?.user_name
				},
				{
					text: this.$t('AuditLog.headers.change'),
					value: 'log_type',
					name: 'logType',
					align: 'center',
					width: 240,
					setValueExpr: val => this.logTypes.find(c => c.logType === val)?.name,
					noNotAvailableText: true
				},
				{
					text: this.$t('AuditLog.headers.changeType'),
					value: 'type',
					name: 'actionType',
					align: 'center',
					width: 240,
					setValueExpr: val => this.actionTypes.find(c => c.type === val)?.name,
				},
				{
					text: this.$t('AuditLog.headers.date'),
					value: 'date_formatted',
					name: 'date',
					width: 200,
					align: 'center'
				},
				{
					text: this.$t('AuditLog.headers.description'),
					value: 'description',
					name: 'description'
				},
				{
					text: '',
					value: 'actions',
					name: 'actions',
					width: 60,
					noNotAvailableText: true
				},
			];
			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass =
					!headers[i].columnClass ? 'px-2' : headers[i].columnClass + ' px-2'
			}
			return headers
		},
	},
	created() {
		this.loading = true;
		Promise.all([
			this.fetchAudits(),
			!this.users.length ? this.$store.dispatch('users/fetchAll') : null,
			!this.materials.length ? this.$store.dispatch('materials/fetchAll') : null,
		]).finally(() => {
			this.loading = false;
		})
	}
}
</script>